import httpClient from "./httpClient";
import router from "../router";

const actionScope = `loader`;

export function setupInterceptors({dispatch}) {
    let requestsPending = 0;

    const req = {
        pending: () => {
            requestsPending++;
            dispatch(`${actionScope}/show`);
        },
        done: () => {
            requestsPending--;

            if (requestsPending <= 0) {
                dispatch(`${actionScope}/hide`);
            }
        },
    };

    httpClient.interceptors.request.use(
        (config) => {
            req.pending();

            return config;
        },
        (error) => {
            requestsPending--;

            req.done();

            return Promise.reject(error);
        }
    );

    httpClient.interceptors.response.use(
        ({data}) => {
            req.done();

            return Promise.resolve(data);
        },
        (error) => {
            if (error.response.status === 401) {
                if (router.history.current.fullPath !== window.location.pathname) {
                    router.push({name: 'Login'})
                }
            }

            req.done();

            return Promise.reject(error);
        }
    );
}
